// src/components/products/ProductForm/GeneralInfoSections/DescriptionsSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const DescriptionsSection = ({
    formData,
    errors,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Short Description */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="الوصف المختصر (عربي)"
                        type="editor"
                        name="short_description_ar"
                        value={formData.short_description?.ar || ''}
                        onChange={(e) =>
                            handleMultiLangChange('short_description', 'ar', e.target.value)
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.short_description_ar}
                        helperText={errors.short_description_ar}
                    />
                </Grid>
            )}

            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Short Description (English)"
                        type="editor"
                        name="short_description_en"
                        value={formData.short_description?.en || ''}
                        onChange={(e) =>
                            handleMultiLangChange('short_description', 'en', e.target.value)
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.short_description_en}
                        helperText={errors.short_description_en}
                    />
                </Grid>
            )}

            {/* Summary */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="الملخص (عربي)"
                        type="editor"
                        name="summary_ar"
                        value={formData.summary?.ar || ''}
                        onChange={(e) =>
                            handleMultiLangChange('summary', 'ar', e.target.value)
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.summary_ar}
                        helperText={errors.summary_ar}
                    />
                </Grid>
            )}

            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Summary (English)"
                        type="editor"
                        name="summary_en"
                        value={formData.summary?.en || ''}
                        onChange={(e) =>
                            handleMultiLangChange('summary', 'en', e.target.value)
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.summary_en}
                        helperText={errors.summary_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default DescriptionsSection;
